module.exports = __webpack_public_path__ + "static/media/32_VTA - Silicon Valley.10cad130.jpg";